module.exports = __webpack_public_path__ + "static/media/tie-silicon-logo.c2ac9422.png";